import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { ShareArtifactWithPositionsRequest } from './shareArtifactWithPositions.types'

export const shareArtifactWithPositions = async ({
  publicId,
  positions
}: ShareArtifactWithPositionsRequest): Promise<void> => {
  await forgeApi.post(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/shares`,
    {
      positions
    }
  )
}

export const useShareArtifactWithPositionsMutation = (
  options?: ExtendableMutationOptions<void, ShareArtifactWithPositionsRequest>
) =>
  useMutation({
    mutationFn: shareArtifactWithPositions,
    ...options
  })
